import Vue from 'vue';
import template from './template.html';
import $ from 'jquery';
import _ from 'lodash';
import {lory} from 'lory.js';

function wrapLetters (word) {
  return word.split('').map(function(char){
    return '<span>' + char + '</span>';
  });
}

function animateWords (tl, words) {
  words.forEach(function(word){
    word.addClass('blur');
  });
}

function animateLetters ($vm, tl, letters) {
  letters.forEach(function(letter){
    tl.fromTo(letter, 2, {opacity: 0, y:'+=10'}, {opacity: 1, y:'-=10', onComplete: function () {
      $vm.$store.dispatch('logoAnimated');
      $vm.$store.dispatch('showNav');
    }}, Math.random());
  });


}

function animateHeading ($vm, heading) {
  var words = heading.text().split(' '),
    wordsArray = [], lettersArray = [],
    tl = new window.TimelineMax();

  heading.html('');

  words.forEach(function(word, index) {
    var wordset = $('<span/>', {id : 'txt' + index}).html(wrapLetters(word)).appendTo(heading);
    wordsArray.push(wordset);
    wordset.find('span').each(function(index, letter){
      lettersArray.push(letter);
    });
  });

  animateWords(tl, wordsArray);
  animateLetters ($vm, tl, lettersArray);
}

export default Vue.component('heroes', {
  template: template,
  data: function () {
    return {
      randomOrder: _.shuffle([0,1,2]),
      activeIndex: 0,
      slider: {},
      textAnimated: false,
      sliding: false
    };
  },
  watch: {
    hasPreloaded () {
      if(!this.logoAnimated) {
        this.animateLogo(0);
      }
    },
    logoAnimated (current) {
      let $vm = this;
      if(current) {
        // every 30seconds next slide
        setInterval(()=>{
          if(!$vm.sliding) {
            $vm.slider.next();
          }
        }, 20000);
      }
    }
  },
  mounted () {
    let $vm  = this;
    this.$h2 = $(this.$el).find('h2').first();
    this.$img = $(this.$el).find('.heroes__intro-image');

    if(this.prevRoute) {
      this.$store.dispatch('logoAnimated');
      this.$store.dispatch('showNav');
      this.textAnimated = true;
      // this.activeIndex = _.random(0,2);
    }

    Vue.nextTick(function () {
      const slider = $vm.$el.querySelector('.js_slider');

      $vm.slider = lory(slider, {
        infinite: 1,
        enableMouseEvents: true
      });
      $vm.slider.slideTo($vm.randomOrder[0]);
      $vm.activeIndex = $vm.randomOrder[0];
      slider.addEventListener('on.lory.resize', function () {
        $vm.slider.slideTo($vm.activeIndex);
      });
      slider.addEventListener('before.lory.slide', function () {
        $vm.sliding = true;
        if($vm.logoAnimated && !$vm.textAnimated) {
          window.TweenMax.to($vm.$h2 , 0.3, {opacity: 0, onComplete: function () {
            setTimeout(() => {
              $vm.textAnimated = true;
            }, 1000);
          }});
        }
      });
      slider.addEventListener('after.lory.slide', function (currentSlide) {
        setTimeout(function () {
          $vm.activeIndex = currentSlide.detail.currentSlide -1;
          $vm.sliding = false;
        }, 1000);
      });
    });
  },
  methods: {
    animateLogo (step) {
      let $vm = this;
      let $img = this.$img;
      if(step < 283) {
        setTimeout(function (){
          window.requestAnimationFrame(function(){
            var url = location.pathname + 'images/hero-sequence/logo';
            var num = '0' + step;
            if(step < 10) {
              num = '000' + step;
            } else if (step < 100) {
              num = '00' + step;
            }
            $img.prop('src', (url + num + '.png'));
            $vm.animateLogo(step+1);
            $vm.animateImages(step+1);

          });

        }, 1000/25);
      } else {
        this.$img.fadeOut(2000, function (){
          $vm.$h2.css('display', 'block');
          animateHeading($vm, $vm.$h2);
        });
      }
    },
    animateImages (step) {
      if (step < 100) {
        // this.activeIndex = this.randomOrder[0];
        this.slider.slideTo(this.randomOrder[0]);
      } else if (step > 100 && step < 170) {
        // this.activeIndex = this.randomOrder[1];
        this.slider.slideTo(this.randomOrder[1]);
      } else {
        // this.activeIndex = this.randomOrder[2];
        this.slider.slideTo(this.randomOrder[2]);
      }
    },
    showSlide (index) {
      this.slider.slideTo(index-1);
    },
    prev () {
      this.slider.prev();
    },
    next () {
      this.slider.next();
    }
  },
  computed: {
    hasPreloaded () {
      return this.$store.state.ui.hasPreloaded;
    },
    logoAnimated () {
      return this.$store.state.ui.logoAnimated;
    },
    content () {
      return this.$store.state.content.home || {};
    },
    prevRoute () {
      return this.$store.state.routes.prevRoute.name;
    },
    activeImage () {
      return this.activeIndex + 1;
    },
    activeHeading () {
      return this.content.images ? this.content.images[this.activeIndex].heading : '';
    },
    prevIndex () {
      let images = this.content.images || [];
      let prev = this.activeIndex - 1;
      if(prev < 0) {
        prev = images.length - 1;
      }
      return prev;
    },
    nextIndex () {
      let images = this.content.images || [];
      let next = this.activeIndex + 1;
      if(next >= images.length) {
        next = 0;
      }
      return next;
    },
    prevTitle () {
      return this.content.images? this.content.images[this.prevIndex].title : '';
    },
    nextTitle () {
      return this.content.images ? this.content.images[this.nextIndex].title : '';
    }
  }
});



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/components/heroes/main.js